export default "__VITE_ASSET__C12ZGnOS__"